import { split, head, last, filter, find, pathOr, equals, toLower, includes, lensPath,set } from 'ramda';
import { TRUE } from 'src/constants';
import { META_DATA } from 'src/services/constants';
import { isNotEmpty } from 'src/utilities/hasValue';
import { filterBySubProduct } from '../helper';
import { mutateSubProduct } from '../Advisors/Applications/SummaryMortgage/commonContext';
import { capitalizeAllWords } from 'src/utilities/capitalize';
import { compose } from 'recompose';

//////
export class LoanProductFinder {
  private rawLoanProducts;
  uriLoanType: any;
  exisitngApps?: any;

  constructor(uriLoanType: any, rawLoanProducts: any[], exisitngApps?: any) {
    this.uriLoanType = uriLoanType;
    this.rawLoanProducts = rawLoanProducts;
    this.exisitngApps = exisitngApps;
  }


  urlSlug() {
    return split('-', this.uriLoanType);
  }

  headURLSlug() {
    return head(this.urlSlug());
  }

  lastURLSlug() {
    return last(this.urlSlug());
  }

  subProductSlug() {
    const productName = capitalizeAllWords(this.lastURLSlug() || '') 
    const loanProduct = this.filterBySubProductName()
    const product: any = head(filterBySubProduct(pathOr([],['subproducts'], loanProduct), 'name', productName));
    return pathOr('', ['name'], product) || productName
  }

  findProductName() {
    return pathOr('', ['product_name'], this.filterBySubProductName());
  }

  filterUnclosedProductsFromExisitngApps() { 
    const subProducts = pathOr([], [0,"subproducts"], this.filterProductByLoanType())
    const filteredSubProducts = filter((product: any) => {
      return !includes(pathOr("", ["name"], product), this.exisitngApps)
    }, subProducts)
    const product= compose(
      set(lensPath([0,"subproducts"]), filteredSubProducts)
    )(this.filterProductByLoanType())
    return isNotEmpty(this.exisitngApps) ? product : this.filterProductByLoanType()
  }



  filterBySubProductName() {
    return find((loanProduct: any) => {
      const subproducts = mutateSubProduct(pathOr([], ['subproducts'], loanProduct));
      return isNotEmpty(
        filterBySubProduct(subproducts, 'value', this.lastURLSlug())
      );
    }, this.rawLoanProducts)
  }
  //if the loantype is passed it will filter the product based on loantype otherwise it will return default products
  filterProductByLoanType() {
    return isNotEmpty(this.uriLoanType)
      ? filter(
        (product) =>
          equals(toLower(pathOr('', ['product_name'], product)), toLower(this.uriLoanType)),
        this.rawLoanProducts
      )
      : this.rawLoanProducts;
  }
  getEnabledProducts() {
    return filter(
      (product) =>
        !equals(pathOr('', [META_DATA, 'skip_on_direct_signup'], product), TRUE),
      this.rawLoanProducts
    )
  }
}
